import { Route, Router } from '@solidjs/router';
import { lazy } from 'solid-js';

const FunnelPage = lazy(() => import('./pages/FunnelPage'));
const LayoutPatchSpikePage = lazy(() => import('./pages/LayoutPatchSpikePage'));
const DOfferPage = lazy(() => import('./pages/DOfferPage'));
const PostPaymentRouter = lazy(() => import('./pages/postpayment/PostPaymentRouter'));

export default function App() {
  return (
    <Router>
      <Route path="/d-offer" component={DOfferPage} />
      <Route path="/success" component={PostPaymentRouter} />
      <Route path="/register" component={PostPaymentRouter} />
      <Route path="/upsells" component={PostPaymentRouter} />
      <Route path="/download" component={PostPaymentRouter} />
      <Route path="/layout-spike" component={LayoutPatchSpikePage} />
      <Route path="/*" component={FunnelPage} />
    </Router>
  );
}
